import _ from 'lodash';
import React, { useCallback } from 'react';

import { validateEmail } from '@/src/globalFunction';

import UserTagInput from '../../../../ComposeEmailForm/Fields/RecipientInput/UserTagInput/UserTagInput';
import InputWithLabelLayout from '../../InputWithLabelLayout';

type RecipientInputFieldProps = {
  onSetFilter: ({ name, withNonMembers }: { name: string; withNonMembers: number }) => void;
  setRecipients: (recipients: any) => void;
  recipients: any[];
  recipientsOptions: any[];
  fieldLabel: string;
  isRequired?: boolean;
  LastComponentSlot?: React.ReactNode;
  onBlur?: (value: string, tags: any[]) => void;
};
const RecipientInputField = ({
  onSetFilter,
  setRecipients,
  fieldLabel,
  recipientsOptions,
  recipients,
  LastComponentSlot = null,
  isRequired = false,
  onBlur = null,
}: RecipientInputFieldProps) => {
  const fetchRecipientsOptions = useCallback(
    async ({
      inputValue,
      withNonMembers,
    }: { inputValue?: string; withNonMembers?: number } = {}) => {
      const params = {
        withNonMembers,
        name: inputValue,
      };

      onSetFilter(params);
    },
    [onSetFilter]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleInputChange = useCallback(
    _.debounce(
      ({ inputValue }) =>
        onSetFilter({
          name: inputValue,
          withNonMembers: 1,
        }),
      500
    ),
    []
  );

  return (
    <InputWithLabelLayout
      label={fieldLabel}
      isRequired={isRequired}
      LastComponentSlot={LastComponentSlot}
    >
      <UserTagInput
        tagKey={fieldLabel}
        options={recipientsOptions}
        hasMore={false}
        tags={recipients}
        setTags={setRecipients}
        defaultTags={[]}
        validateInput={validateEmail}
        classes={'emailRecipientOptions'}
        onInputChange={handleInputChange}
        onClickDropdown={fetchRecipientsOptions}
        onBlur={onBlur}
        fetchOptions={fetchRecipientsOptions}
      />
    </InputWithLabelLayout>
  );
};

export default RecipientInputField;
